module.exports = __webpack_public_path__ + "img/logo.91217038.png";